import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useToast } from "../../context/ToastContext";
import LineApi from "../../services/LineApi";
import AreaApi from "../../services/AreaApi";
import ProductionUnitApi from "../../services/ProductionUnitApi";

import Input from "../../components/Input/Input";
import FormCard from "../../components/FormCard/FormCard";

const LineDetails: React.FC = () => {
  const { t: translateForm } = useTranslation("form");
  const { t: translateMessage } = useTranslation("messages");
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { displayToast } = useToast();

  const [name, setName] = useState<string>("");
  const [areaLabel, setAreaLabel] = useState<string>("");
  const [unitLabel, setUnitLabel] = useState<string>("");

  useEffect(() => {
    if (!id) {
      navigate("/lines");
      return;
    }

    const fetchLine = async (lineId: string): Promise<void> => {
      try {
        const resp = await LineApi.GetLineById(lineId);
        const line = resp.data;
        setName(line?.name ?? "");

        let unitName = "—";

        if (line?.areaId) {
          try {
            const areaResp = await AreaApi.GetAreaById(line.areaId);
            const area = areaResp.data;
            setAreaLabel(area?.name ?? "—");

            if (area.productionUnit?.name) {
              unitName = area.productionUnit.name;
            } else if (area.productionUnitId) {
              try {
                const puResp = await ProductionUnitApi.GetProductUnitById(area.productionUnitId);
                const pu = puResp.data;
                unitName = pu?.name ?? pu?.nome ?? "—";
              } catch (e) {
                displayToast("error", translateMessage("error"), translateMessage("errorLoadUnit"), false, 3000);
              }
            }
          } catch (err) {
            setAreaLabel("—");
          }
        } else {
          setAreaLabel("—");
        }
        setUnitLabel(unitName);
      } catch (err) {
        displayToast("error", translateMessage("error"), "", false, 3000);
        navigate("/lines");
      }
    };

    fetchLine(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleBack = (): void => {
    navigate("/lines");
  };

  return (
    <FormCard
      title={translateForm("viewLine")}
      icon="info"
      onSubmit={() => {}}
      onCancel={handleBack}
      cancelButtonLabel={translateForm("back")}
      numColumns={12}
      disabled
    >
      {/* Unidade de Produção */}
      <div style={{ gridColumn: "span 4" }}>
        <Input
          type="text"
          label={translateForm("productionUnit")}
          value={unitLabel || "—"}
          onChange={() => {}}
          disabled
        />
      </div>
      {/* Área */}
      <div style={{ gridColumn: "span 4" }}>
        <Input
          type="text"
          label={translateForm("area")}
          value={areaLabel || "—"}
          onChange={() => {}}
          disabled
        />
      </div>
      {/* Nome da Linha */}
      <div style={{ gridColumn: "span 4" }}>
        <Input
          type="text"
          label={translateForm("name")}
          value={name || "—"}
          onChange={() => {}}
          disabled
        />
      </div>
    </FormCard>
  );
};

export default LineDetails;
